import { IAppState } from '../common/state';

export const getCommercialFiltersMarkup = (state: IAppState) => state.commercialFiltersMarkup;
